export default __webpack_public_path__ + "static/media/tommy-hearns-faqs.2657a590.png";